import React, { useContext } from 'react'
import { Label, RadioButton, RadioGroup } from '@americanexpress/dls-react';
import userContext from '../../components/ContextComponent/UserContext';

function BillingAddress() {
    const { formData, setFormData } = useContext(userContext);
    const valueChange = (e) => {
        setFormData({ ...formData, billingAddress: e.target.value });
    }
    return (
        <div>
            <Label htmlFor="smartfield" className="label-1">Correspondence, billing, and card delivery address</Label>
            <RadioGroup
                defaultChecked="HomeAddress"
                className="flex flex-align-items-start stack-1-r pad-1-t" onChange={valueChange}>
                <RadioButton id="IsHomeAddress" name="IsHomeAddress" label="Current Address" className="pad-2-r" value="HomeAddress" />
                <RadioButton id="IsCompanyAddress" name="IsCompanyAddress" label="Company Address" value="CompanyAddress" />
            </RadioGroup>
        </div>
    );
}
export default BillingAddress;